// Хугацааны бичиг: "10/30-ны дотор", "11/01-ний дотор" — өдрийн тооны дуудлагаар харьяалахын нөхцөл
import dayjs from "dayjs";

// 1 нэгний, 2 хоёрын, 3 гурвын, 4 дөрвийн, 5 тавын, 6 зургаагийн, 7 долоогийн, 8 наймын, 9 есийн; 10 аравын, 20 хорины, 30 гучны
const ONES = ["", "ний", "ын", "ын", "ийн", "ын", "гийн", "гийн", "ын", "ийн"];
const TENS = { 1: "ын", 2: "ны", 3: "ны" };

export const genitive = (n) => (n % 10 ? ONES[n % 10] : TENS[Math.floor(n / 10)] || "ын");

// dueText("2026-10-30") → "10/30-ны дотор"
export const dueText = (date) => {
  const d = dayjs(date);
  return `${d.format("MM/DD")}-${genitive(d.date())} дотор`;
};
